import { createSelector } from "@reduxjs/toolkit";
import { RootState } from "types";
import { timeSheetInitialState } from "./initialState";

const selectDomain = (state: RootState) =>
  state?.timeSheetState || timeSheetInitialState;

export const selectTimeSheetLoading = createSelector(
  [selectDomain],
  (state) => state?.timeSheet.loading,
);

export const selectTimeSheetData = createSelector(
  [selectDomain],
  (state) => state?.timeSheet.data,
);

export const selectTimeSheetEntryDeleteLoading = createSelector(
  [selectDomain],
  (state) => state?.timeSheetEntryDeleteLoading,
);

export const selectTimeSheetPagination = createSelector(
  [selectDomain],
  (state) => state?.timeSheet.pagination,
);

export const selectTimeSheetHasMore = createSelector(
  [selectDomain],
  (state) => {
    const { page, totalPage } = state?.timeSheet.pagination;
    return page < totalPage;
  },
);

export const selectTimeSheetLoadingMore = createSelector(
  [selectDomain],
  (state) => state?.timeSheet.loadingMore,
);

export const selectTimeTrackerForm = createSelector(
  [selectDomain],
  (state) => state?.timeTrackerForm,
);

export const selectEffortActualRequestLoading = createSelector(
  [selectDomain],
  (state) => state.effortActualRequestLoading,
);

export const selectEnableTimeTrackerPreview = createSelector(
  [selectDomain],
  (state) => state?.enableTimeTrackerPreview,
);

export const selectActiveTimerForm = createSelector(
  [selectDomain],
  (state) => state?.activeTimerForm,
);

// Ticket List --
export const selectTimeSheetTicketList = createSelector(
  [selectDomain],
  (state) => state.timeSheetTicketList,
);

export const selectTimeSheetTicketHasMore = createSelector(
  [selectDomain],
  (state) => {
    return (
      state.timeSheetTicketList.pagination.page <
      state.timeSheetTicketList.pagination.totalPage
    );
  },
);

export const selectTimeSheetTicketListSearchQuery = createSelector(
  [selectDomain],
  (state) => state.timeSheetTicketListSearchQuery,
);
// --
